import styled from "styled-components";

export const Back = styled.img`
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;
  width: 100%;

  @media screen and (max-width: 960px) {
    content: url("/image/lp/kaleido/bg/long/bg-sp.png");
  }
  @media screen and (min-width: 961px) {
    content: url("/image/lp/kaleido/bg/long/bg-pc-compression.png");
  }

  @media screen and (max-width: 260px) {
  top: 618vw;
  height: 900vw;
  }
  @media screen and (min-width: 261px) {
    top: 618vw;
    height: 825vw;
  }
  @media screen and (min-width: 271px) {
    top: 618vw;
    height: 790vw;
  }
  @media screen and (min-width: 281px) {
    top: 618vw;
    height: 785vw;
  }
  @media screen and (min-width: 291px) {
    top: 618vw;
    height: 770vw;
  }
  @media screen and (min-width: 301px) {
    top: 618vw;
    height: 745vw;
  }
  @media screen and (min-width: 311px) {
    top: 618vw;
    height: 735vw;
  }
  @media screen and (min-width: 331px) {
    top: 618vw;
    height: 720vw;
  }
  @media screen and (min-width: 341px) {
    top: 613vw;
    height: 710vw;
  }
  @media screen and (min-width: 361px) {
    top: 613vw;
    height: 700vw;
  }
  @media screen and (min-width: 376px) {
    top: 611vw;
    height: 685vw;
  }
  @media screen and (min-width: 391px) {
    top: 610vw;
    height: 675vw;
  }
  @media screen and (min-width: 411px) {
    top: 610vw;
    height: 665vw;
  }
  @media screen and (min-width: 421px) {
    top: 608vw;
    height: 655vw;
  }
  @media screen and (min-width: 451px) {
    top: 606vw;
    height: 640vw;
  }
  @media screen and (min-width: 461px) {
    top: 623vw;
    height: 625vw;
  }
  @media screen and (min-width: 481px) {
    top: 620vw;
    height: 620vw;
  }
  @media screen and (min-width: 501px) {
    top: 620vw;
    height: 615vw;
  }
  @media screen and (min-width: 511px) {
    top: 618vw;
    height: 615vw;
  }
  @media screen and (min-width: 541px) {
    top: 616vw;
    height: 590vw;
  }
  @media screen and (min-width: 571px) {
    top: 614vw;
    height: 578vw;
  }
  @media screen and (min-width: 601px) {
    top: 612vw;
    height: 568vw;
  }
  @media screen and (min-width: 631px) {
    top: 610vw;
    height: 560vw;
  }
  @media screen and (min-width: 661px) {
    top: 615vw;
    height: 548vw;
  }
  @media screen and (min-width: 691px) {
    top: 613vw;
    height: 542vw;
  }
  @media screen and (min-width: 721px) {
    top: 612vw;
    height: 535vw;
  }
  @media screen and (min-width: 751px) {
    top: 611vw;
    height: 525vw;
  }
  @media screen and (min-width: 781px) {
    top: 610vw;
    height: 520vw;
  }
  @media screen and (min-width: 811px) {
    top: 608vw;
    height: 515vw;
  }
  @media screen and (min-width: 841px) {
    top: 607vw;
    height: 507vw;
  }
  @media screen and (min-width: 871px) {
    top: 605vw;
    height: 505vw;
  }
  @media screen and (min-width: 901px) {
    top: 603vw;
    height: 498vw;
  }
  @media screen and (min-width: 931px) {
    top: 600vw;
    height: 490vw;
  }
  
  @media screen and (min-width: 961px) {
    top: 2950px;
    height: 4500px;
  }
  @media screen and (min-width: 1001px) {
    top: 3050px;
    height: 4570px;
  }
  @media screen and (min-width: 1051px) {
    top: 3100px;
    height: 4570px;
  }
  @media screen and (min-width: 1101px) {
    top: 3150px;
    height: 4550px;
  }
  @media screen and (min-width: 1111px) {
    top: 3200px;
    height: 4530px;
  }
  @media screen and (min-width: 1151px) {
    top: 3220px;
    height: 4550px;
  }
  @media screen and (min-width: 1201px) {
    top: 3250px;
    height: 4550px;
  }
  @media screen and (min-width: 1251px) {
    top: 3250px;
    height: 4580px;
  }
  @media screen and (min-width: 1281px) {
    top: 3250px;
    height: 4810px;
  }
  @media screen and (min-width: 1351px) {
    top: 3450px;
    height: 4460px;
  }
  @media screen and (min-width: 1451px) {
    top: 3520px;
    height: 4460px;
  }
  @media screen and (min-width: 1501px) {
    top: 3580px;
    height: 4550px;
  }
  @media screen and (min-width: 1551px) {
    top: 3620px;
    height: 4500px;
  }
  @media screen and (min-width: 1601px) {
    top: 3650px;
    height: 4500px;
  }
  @media screen and (min-width: 1701px) {
    top: 3700px;
    height: 4500px;
  }
  @media screen and (min-width: 1801px) {
    top: 3750px;
    height: 4500px;
  }
  @media screen and (min-width: 1901px) {
    top: 3800px;
    height: 4550px;
  }
  @media screen and (min-width: 2001px) {
    top: 3880px;
    height: 4550px;
  }
  @media screen and (min-width: 2101px) {
    top: 3950px;
    height: 4550px;
  }
  @media screen and (min-width: 2201px) {
    top: 4050px;
    height: 4470px;
  }
  @media screen and (min-width: 2301px) {
    top: 4120px;
    height: 4430px;
  }
    
  @media screen and (min-width: 2401px) {
    width: 2400px;
    height: 4530px;
  }

  @media screen and (min-width: 2401px) {
    top: 4200px;
  }
  @media screen and (min-width: 2501px) {
    top: 4250px;
  }
  @media screen and (min-width: 2601px) {
    top: 4300px;
  }
  @media screen and (min-width: 2701px) {
    top: 4380px;
  }
  @media screen and (min-width: 2801px) {
    top: 4450px;
  }
  @media screen and (min-width: 2901px) {
    top: 4500px;
  }
  @media screen and (min-width: 3001px) {
    top: 4580px;
  }
  @media screen and (min-width: 3101px) {
    top: 4650px;
  }
  @media screen and (min-width: 3201px) {
    top: 4700px;
  }
  @media screen and (min-width: 3301px) {
    top: 4750px;
  }
  @media screen and (min-width: 3401px) {
    top: 4830px;
  }
  @media screen and (min-width: 3501px) {
    top: 4900px;
  }
  @media screen and (min-width: 3601px) {
    top: 4950px;
  }
  @media screen and (min-width: 3701px) {
    top: 5020px;
  }
  @media screen and (min-width: 3801px) {
    top: 5100px;
  }
  @media screen and (min-width: 3901px) {
    top: 5150px;
  }
  @media screen and (min-width: 4001px) {
    top: 5200px;
  }
  @media screen and (min-width: 4201px) {
    top: 5350px;
  }
  @media screen and (min-width: 4401px) {
    top: 5480px;
  }
  @media screen and (min-width: 4601px) {
    top: 5600px;
  }
  @media screen and (min-width: 4801px) {
    top: 5720px;
  }
  @media screen and (min-width: 5001px) {
    top: 5850px;
  }
`;

export const Back2 = styled.img`
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  z-index: -2;
  width: 100%;
  background-repeat: repeat-y;
  
  @media screen and (max-width: 960px) {
    content: url("/image/lp/kaleido/bg/long/bg-sp.png");
  }
  @media screen and (min-width: 961px) {
    content: url("/image/lp/kaleido/bg/long/bg-pc-bottom.png");
  }
  @media screen and (min-width: 1351px) {
    content: url("/image/lp/kaleido/bg/long/bg-pc-bottom3.png");
  }

  @media screen and (max-width: 260px) {
    top: 705vw;
    height: 620vw;
  }
  @media screen and (min-width: 261px) {
    top: 705vw;
    height: 610vw;
  }
  @media screen and (min-width: 271px) {
    top: 700vw;
    height: 580vw;
  }
  @media screen and (min-width: 281px) {
    top: 672vw;
    height: 610vw;
  }
  @media screen and (min-width: 291px) {
    top: 671vw;
    height: 590vw;
  }
  @media screen and (min-width: 301px) {
    top: 667vw;
    height: 575vw;
  }
  @media screen and (min-width: 311px) {
    top: 668vw;
    height: 560vw;
  }
  @media screen and (min-width: 331px) {
    top: 664vw;
    height: 545vw;
  }
  @media screen and (min-width: 341px) {
    top: 652vw;
    height: 540vw;
  }
  @media screen and (min-width: 351px) {
    top: 652vw;
    height: 540vw;
  }
  @media screen and (min-width: 361px) {
    top: 648vw;
    height: 545vw;
  }
  @media screen and (min-width: 376px) {
    top: 646vw;
    height: 530vw;
  }
  @media screen and (min-width: 391px) {
    top: 645vw;
    height: 520vw;
  }
  @media screen and (min-width: 401px) {
    top: 645vw;
    height: 525vw;
  }
  @media screen and (min-width: 411px) {
    top: 657vw;
    height: 505vw;
  }
  @media screen and (min-width: 421px) {
    top: 650vw;
    height: 500vw;
  }
  @media screen and (min-width: 431px) {
    top: 642vw;
    height: 500vw;
  }
  @media screen and (min-width: 441px) {
    top: 632vw;
    height: 505vw;
  }
  @media screen and (min-width: 451px) {
    top: 645vw;
    height: 490vw;
  }
  @media screen and (min-width: 461px) {
    top: 662vw;
    height: 485vw;
  }
  @media screen and (min-width: 471px) {
    top: 652vw;
    height: 485vw;
  }
  @media screen and (min-width: 481px) {
    top: 653vw;
    height: 480vw;
  }
  @media screen and (min-width: 491px) {
    top: 647vw;
    height: 480vw;
  }
  @media screen and (min-width: 501px) {
    top: 642vw;
    height: 480vw;
  }
  @media screen and (min-width: 511px) {
    top: 635vw;
    height: 475vw;
  }
  @media screen and (min-width: 541px) {
    top: 633vw;
    height: 470vw;
  }
  @media screen and (min-width: 571px) {
    top: 629vw;
    height: 460vw;
  }
  @media screen and (min-width: 591px) {
    top: 620vw;
    height: 460vw;
  }
  @media screen and (min-width: 601px) {
    top: 625vw;
    height: 455vw;
  }
  @media screen and (min-width: 631px) {
    top: 621vw;
    height: 448vw;
  }
  @media screen and (min-width: 661px) {
    top: 628vw;
    height: 440vw;
  }
  @media screen and (min-width: 691px) {
    top: 628vw;
    height: 435vw;
  }
  @media screen and (min-width: 721px) {
    top: 625vw;
    height: 430vw;
  }
  @media screen and (min-width: 751px) {
    top: 627vw;
    height: 425vw;
  }
  @media screen and (min-width: 781px) {
    top: 622vw;
    height: 420vw;
  }
  @media screen and (min-width: 811px) {
    top: 620vw;
    height: 416vw;
  }
  @media screen and (min-width: 841px) {
    top: 620vw;
    height: 410vw;
  }
  @media screen and (min-width: 861px) {
    top: 620vw;
    height: 420vw;
  }
  @media screen and (min-width: 871px) {
    top: 619vw;
    height: 420vw;
  }
  @media screen and (min-width: 901px) {
    top: 616vw;
    height: 410vw;
  }
  @media screen and (min-width: 931px) {
    top: 614vw;
    height: 405vw;
  }
  

  @media screen and (min-width: 961px) {
    height: 45vw;
  }

  @media screen and (min-width: 961px) {
    top: 7400px;
  }
  @media screen and (min-width: 1001px) {
    top: 7550px;
  }
  @media screen and (min-width: 1111px) {
    top: 7600px;
  }
  @media screen and (min-width: 1151px) {
    top: 7680px;
  }
  @media screen and (min-width: 1201px) {
    top: 7680px;
  }
  @media screen and (min-width: 1251px) {
    top: 7730px;
  }
  @media screen and (min-width: 1281px) {
    top: 8000px;
  }

  @media screen and (min-width: 1351px) {
    height: 40vw;
  }

  @media screen and (min-width: 1351px) {
    top: 7910px;
  }
  @media screen and (min-width: 1451px) {
    top: 7950px;
  }
  @media screen and (min-width: 1501px) {
    top: 8100px;
  }
  @media screen and (min-width: 1551px) {
    top: 8100px;
  }
  @media screen and (min-width: 1601px) {
    top: 8140px;
  }
  @media screen and (min-width: 1701px) {
    top: 8200px;
  }
  @media screen and (min-width: 1801px) {
    top: 8200px;
  }
  @media screen and (min-width: 1901px) {
    top: 8300px;
  }
  @media screen and (min-width: 2001px) {
    top: 8300px;
  }
  @media screen and (min-width: 2101px) {
    top: 8350px;
  }
  @media screen and (min-width: 2201px) {
    top: 8350px;
  }
  @media screen and (min-width: 2301px) {
    top: 8400px;
  }

  @media screen and (min-width: 2401px) {
    width: 2400px;
    height:30vw;
  }

  @media screen and (min-width: 2401px) {
    top: 8705px;
  }
  @media screen and (min-width: 2501px) {
    top: 8705px;
  }
  @media screen and (min-width: 2601px) {
    top: 8805px;
  }
  @media screen and (min-width: 2701px) {
    top: 8855px;
  }
  @media screen and (min-width: 2801px) {
    top: 8900px;
  }
  @media screen and (min-width: 2901px) {
    top: 9000px;
  }
  @media screen and (min-width: 3001px) {
    top: 9050px;
  }
  @media screen and (min-width: 3101px) {
    top: 9150px;
  }
  @media screen and (min-width: 3201px) {
    top: 9200px;
  }
  @media screen and (min-width: 3301px) {
    top: 9250px;
  }
  @media screen and (min-width: 3401px) {
    top: 9350px;
  }
  @media screen and (min-width: 3501px) {
    top: 9400px;
  }
  @media screen and (min-width: 3601px) {
    top: 9450px;
  }
  @media screen and (min-width: 3701px) {
    top: 9550px;
  }
  @media screen and (min-width: 3801px) {
    top: 9600px;
  }
  @media screen and (min-width: 3901px) {
    top: 9650px;
  }
  @media screen and (min-width: 4001px) {
    top: 9700px;
  }
  @media screen and (min-width: 4201px) {
    top: 9800px;
  }
  @media screen and (min-width: 4401px) {
    top: 9900px;
  }
  @media screen and (min-width: 4601px) {
    top: 10000px;
  }
  @media screen and (min-width: 4801px) {
    top: 10150px;
  }
  @media screen and (min-width: 5001px) {
    top: 10200px;
  }
`;
